import React, { useEffect, useMemo, useState } from 'react';
import {
  Table,
  Button,
  Select,
  Input,
  Card,
  Row,
  Col,
  Modal,
  message,
  Space,
  DatePicker,
  Typography,
  Progress,
  Tooltip,
  Tag,
  Popconfirm,
  Tabs
} from 'antd';
import {
  ClearOutlined,
  DownloadOutlined,
  EditFilled,
  EditTwoTone,
  ExportOutlined,
  FilterFilled,
  FilterOutlined,
  SearchOutlined,
  SyncOutlined,
  UploadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import { URL_API } from '@configs/';
import './style.css';
import { showError } from '@components/notification';
import { communityList, convertLocaltimeToUTC, formatCurrency, isNullOrEmpty } from '@utils/utils';
import {
  apiGetOriginalData,
  apiSyncData,
  apiSyncTimeData
} from '@services/ManageDevices/DeviceServices';
import { loadFromLocalStorageObjectFromBase64, saveToLocalStorage } from '@databases/localStorage';
import { contantAuthentication } from '@contants/';
import { get, isEmpty, isNumber } from 'lodash';
import { SelectCommunity } from '@page/Common/SelectCommunity';
import {
  apiCalculateStatisticsMonth,
  apiGetStatisticsData,
  apiGetStatisticsDataByMonth,
  apiGetStatisticsDataByMonthByCustomerV2,
  apiGetStatisticsDataByMonthDetail,
  apiGetStatisticsDataByMonthV2,
  apiGetStatisticsDataByMonthV3
} from '@services/ManageCustomers/CustomerServices';
import { apiGetFavoriteFilters } from '@services/ManageCustomers/FavoriteFilterServices';
import { ADMIN_ROLE } from '@utils/constant';
import Chart from '@components/charts/Chart';
import Loading from '@components/Loading';
import { COLORS } from '@components/charts/chart.constant';
import ModalAdjustConsumption from './ModalAdjustConsumption';
import { usePermission } from '@contexts/Auth/UsePermission';
import FilterAdvanceDrawer from '@components/FilterAdvance';
import ConsumptionCard from './ConsumptionCard';
import ModalUpdateStartMeterReading from './ModalUpdateStartMeterReading';
import ModalUpdateEndMeterReading from './ModalUpdateEndMeterReading';
import ProcessManagementList from './ProcessManagementList';
import ModalImportManualReadings from './ModalImportManualReadings';

const { Option } = Select;

const { RangePicker } = DatePicker;

export default function List() {
  const [data, setData] = useState([]);
  const [flagSearch, setFlagSearch] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCommunity, setSelectedCommunity] = useState('HP');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [custId, setCustId] = useState(null);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const previousMonthDate = moment();
  const [selectedMonth, setSelectedMonth] = useState(previousMonthDate.format('YYYY-MM'));
  const [selectedYear, setSelectedYear] = useState(previousMonthDate.year());
  const user = JSON.parse(loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH));
  const [dataCharts, setDataCharts] = useState([]);
  const [labelCharts, setLabelCharts] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [isOpenModalAdjust, setIsOpenModalAdjust] = useState(false);
  const [adjustRow, setAdjustRow] = useState('');
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRow, setSelectedRow] = useState({});
  const [isOpenModalStartMeter, setIsOpenModalStartMeter] = useState(false);
  const [startMeterRow, setStartMeterRow] = useState('');
  const [isOpenModalEndMeter, setIsOpenModalEndMeter] = useState(false);
  const [endMeterRow, setEndMeterRow] = useState('');
  const [isOpenModalProcess, setIsOpenModalProcess] = useState(false);
  const [isOpenModalImport, setIsOpenModalImport] = useState(false);

  const { consumption } = usePermission();
  const [isOpen, setIsOpen] = useState(false);
  const [dataFilterAdvance, setDataFilterAdvance] = useState({});
  const [dataStatus, setDataStatus] = useState(null);
  const [activeTab, setActiveTab] = useState('all');
  const [favoriteFilters, setFavoriteFilters] = useState([]);
  const [selectedFavoriteFilter, setSelectedFavoriteFilter] = useState(null);
  const [loadingFavoriteFilters, setLoadingFavoriteFilters] = useState(false);

  const openDrawer = () => {
    setIsOpen(true);
  };

  const onDrawerClose = () => {
    setIsOpen(false);
  };

  // Fetch favorite customer filters
  const fetchFavoriteFilters = async () => {
    try {
      setLoadingFavoriteFilters(true);
      const res = await apiGetFavoriteFilters();
      const customerFilters = (res.data?.data || []).filter((f) => f.filter_type === 'customer');
      setFavoriteFilters(
        customerFilters.map((f) => ({
          label: `${f.filter_name} (${f.item_ids?.length || 0} KH)`,
          value: f.id,
          item_ids: f.item_ids
        }))
      );
    } catch (err) {
      console.error('Error fetching favorite filters:', err);
    } finally {
      setLoadingFavoriteFilters(false);
    }
  };

  useEffect(() => {
    fetchFavoriteFilters();
  }, []);

  const fetchData = async () => {
    try {
      setSelectedRowKey(null);
      setLoadingFetch(true);
      const fromDate = moment(selectedMonth + '-01');
      const res = await apiGetStatisticsDataByMonthV3({
        page: currentPage,
        size: pageSize,
        keyWord: search ?? undefined,
        community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
        period: fromDate.format('YYYY-MM-DD'), // convertLocaltimeToUTC(fromDate, '00:00:00.000'),
        dataStatus: dataStatus ?? undefined,
        listCust: selectedFavoriteFilter
          ? favoriteFilters.find((f) => f.value === selectedFavoriteFilter)?.item_ids?.join(',')
          : undefined,
        ...dataFilterAdvance
      });
      setData(
        res.data?.data?.map((item, index) => ({
          ...item,
          stt: (currentPage - 1) * pageSize + 1 + index
        }))
      );
      setTotalItems(res.data?.meta?.total);
    } catch (err) {
      setData([]);
      setSelectedRowKey(null);
      console.log(err);
    } finally {
      setLoadingFetch(false);
    }
  };
  const generateYearOptions = () => {
    const years = [];
    const currentYear = moment().year();
    const currentMonth = moment().month() + 1; // moment().month() returns 0-11
    const startYear = currentMonth === 12 ? currentYear + 1 : currentYear;
    for (let y = startYear; y >= currentYear - 1; y--) {
      years.push({ label: `Năm ${y}`, value: y });
    }
    return years;
  };
  const generateMonthOptions = () => {
    const months = [];
    const current = moment();
    const isCurrentYear = selectedYear === current.year();
    const isFutureYear = selectedYear > current.year();

    // If future year, only show months 1-12
    if (isFutureYear) {
      for (let m = 11; m >= 0; m--) {
        const monthMoment = moment(`${selectedYear}-01-01`).add(m, 'months');
        months.push({
          label: `Tháng cước ${monthMoment.format('MM/YYYY')}`,
          value: monthMoment.format('YYYY-MM')
        });
      }
    } else {
      // Current year or past year
      const startOfYear = moment(`${selectedYear}-01-01`);
      const endMonth = isCurrentYear ? current.month() : 11;

      for (let m = endMonth; m >= 0; m--) {
        const monthMoment = startOfYear.clone().add(m, 'months');
        months.push({
          label: `Tháng cước ${monthMoment.format('MM/YYYY')}`,
          value: monthMoment.format('YYYY-MM')
        });
      }
    }
    return months;
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    setSelectedMonth(null); // Reset month selection when year changes
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === 'all') {
      setDataStatus(null);
    } else if (key === 'with_data') {
      setDataStatus('with_data');
    } else if (key === 'without_data') {
      setDataStatus('without_data');
    } else if (key === 'manual_reading') {
      setDataStatus('manual_reading');
    } else if (key === 'not_yet_reading_date') {
      setDataStatus('not_yet_reading_date');
    }
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
  const onChangeDateRange = (dates, dateStrings) => {
    setDateRange(dates);
  };

  const ActionAdjustColumn = ({ record }) => {
    const handleEdit = async (record) => {
      setAdjustRow(record);
      setIsOpenModalAdjust(true);
    };
    return (
      <>
        {consumption.adjustConsumption && (
          <>
            <Tooltip title="Điều chỉnh tiêu thụ">
              <Button
                type="text"
                shape="circle"
                icon={<EditTwoTone style={{ color: '#0051A9', fontSize: '18px' }} />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          </>
        )}
      </>
    );
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, flagSearch, dataStatus]);

  const columns = [
    {
      title: 'DBĐD',
      dataIndex: 'customer_id',
      key: 'customer_id',
      fixed: 'left',
      width: 100,
      filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#fff' : '#aaa' }} />,
      filters: data.map((item) => ({ text: item.customer_id, value: item.customer_id })),
      onFilter: (value, record) => record.customer_id === value
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      fixed: 'left',
      width: 200,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Tìm khách hàng"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small">
              Tìm kiếm
            </Button>
            <Button onClick={() => clearFilters()} size="small">
              Xoá lọc
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#fff' : '#aaa' }} />,
      onFilter: (value, record) => record.customer_name.toLowerCase().includes(value.toLowerCase())
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      width: 200
    },
    {
      title: 'Nhà máy',
      dataIndex: 'branch',
      width: 100
    },
    {
      title: 'TQL',
      dataIndex: 'manage_group',
      width: 100
    },
    {
      title: 'ĐHT',
      dataIndex: 'parent_device',
      width: 100
    },
    {
      title: 'Mạng lưới',
      dataIndex: 'route',
      key: 'route',
      width: 100,
      filters: [...new Set(data.map((item) => item.route))].map((route) => ({
        text: route,
        value: route
      })),
      filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#fff' : '#aaa' }} />,
      onFilter: (value, record) => record.route === value
    },

    {
      title: 'Cỡ ĐH',
      dataIndex: 'size',
      width: 90
    },
    {
      title: 'Kỳ hoá đơn',
      dataIndex: 'period',
      key: 'period',
      render: (_, record) => (
        <>{record?.period ? moment(record?.period).format('MM/YYYY') : 'N/A'}</>
      ),
      width: 120
    },
    {
      title: 'Từ ngày',
      dataIndex: 'first_day',
      key: 'first_day',
      width: 150
    },
    {
      title: 'Đến ngày',
      dataIndex: 'last_day',
      key: 'last_day',
      width: 150
    },
    {
      title: <div>Chỉ số cũ (m3)</div>,
      children: [
        {
          title: 'Hệ thống',
          dataIndex: 'start_reading',
          key: 'start_reading',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.start_reading)
                ? formatCurrency(record?.start_reading, 3)
                : 'N/A'}
            </>
          ),
          width: 150
        },
        {
          title: 'Đọc thủ công',
          dataIndex: 'start_meter_reading_manual',
          key: 'start_meter_reading_manual',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.start_meter_reading_manual)
                ? formatCurrency(record?.start_meter_reading_manual, 3)
                : 'N/A'}
              {consumption.manualImport && (
                <Tooltip title="Cập nhật chỉ số cũ thủ công">
                  <Button
                    type="text"
                    shape="circle"
                    icon={<EditFilled style={{ color: '#52c41a', fontSize: '16px' }} />}
                    onClick={() => {
                      setStartMeterRow(record);
                      setIsOpenModalStartMeter(true);
                    }}
                    style={{ marginLeft: '8px' }}
                  />
                </Tooltip>
              )}
            </>
          ),
          width: 180
        }
      ]
    },

    {
      title: <div>Chỉ số mới (m3)</div>,
      children: [
        {
          title: 'Hệ thống',
          dataIndex: 'end_reading',
          key: 'end_reading',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.end_reading) ? formatCurrency(record?.end_reading, 3) : 'N/A'}
            </>
          ),
          width: 150
        },
        {
          title: 'Đọc thủ công',
          dataIndex: 'end_meter_reading_manual',
          key: 'end_meter_reading_manual',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.end_meter_reading_manual)
                ? formatCurrency(record?.end_meter_reading_manual, 3)
                : 'N/A'}
              {consumption.manualImport && (
                <Tooltip title="Cập nhật chỉ số mới thủ công">
                  <Button
                    type="text"
                    shape="circle"
                    icon={<EditFilled style={{ color: '#faad14', fontSize: '16px' }} />}
                    onClick={() => {
                      setEndMeterRow(record);
                      setIsOpenModalEndMeter(true);
                    }}
                    style={{ marginLeft: '8px' }}
                  />
                </Tooltip>
              )}
            </>
          ),
          width: 180
        }
      ]
    },

    {
      title: (
        <div>
          <div>Tiêu thụ (m3)</div>
          <span style={{ fontSize: 13, color: '#fff', fontWeight: '400px' }}>
            Tính cước = Hệ thống + Điều chỉnh
          </span>
        </div>
      ),
      children: [
        {
          title: 'Hệ thống',
          dataIndex: 'consumption',
          key: 'consumption',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.consumption) ? formatCurrency(record?.consumption, 3) : 'N/A'}
            </>
          ),
          width: 150
        },
        {
          title: 'Điều chỉnh',
          dataIndex: 'adjusted_consumption_value',
          key: 'adjusted_consumption_value',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.adjusted_consumption_value)
                ? formatCurrency(record?.adjusted_consumption_value, 3)
                : ''}
              <ActionAdjustColumn record={record} />
            </>
          ),
          width: 160
        },
        {
          title: 'Tính Cước',
          dataIndex: 'final_consumption',
          key: 'final_consumption',
          render: (_, record) => (
            <>
              {!isNullOrEmpty(record?.final_consumption)
                ? formatCurrency(record?.final_consumption, 3)
                : 'N/A'}
            </>
          ),
          width: 180
        }
      ]
    },

    {
      title: 'Hình ảnh đọc số',
      dataIndex: 'images',
      key: 'images',
      width: 200,
      render: (_, record) => (
        <div>
          {record.start_meter_reading_manual_image?.url && (
            <div>
              <a
                href={record.start_meter_reading_manual_image.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0051A9', textDecoration: 'underline' }}>
                Ảnh chỉ số cũ thủ công
              </a>
            </div>
          )}

          {record.end_meter_reading_manual_image?.url && (
            <div>
              <a
                href={record.end_meter_reading_manual_image.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0051A9', textDecoration: 'underline' }}>
                Ảnh chỉ số mới thủ công
              </a>
            </div>
          )}
        </div>
      )
    },

    {
      title: 'Ghi chú',
      dataIndex: 'note',
      key: 'note',
      render: (_, record) => (
        <div>
          {record.status === 0 ? (
            <Tag color="orange">Chưa gán</Tag>
          ) : record.status === 1 ? (
            <Tag color="red">Chưa đủ dữ liệu tính toán</Tag>
          ) : record.status === 3 ? (
            <Tag color="blue">
              Tính toán dựa trên dữ liệu nhập thủ công do khách hàng chưa lắp hoặc chưa khai báo lắp
              đặt module đọc số trong kỳ tính cước
            </Tag>
          ) : null}

          {!isNullOrEmpty(record?.remarks) && (
            <div style={{ marginTop: '4px' }}>
              <strong>Lý do điều chỉnh:</strong> {record.remarks}
            </div>
          )}

          {!isNullOrEmpty(record?.start_meter_reading_manual_reason) && (
            <div style={{ marginTop: '4px' }}>
              <strong>Lý do đc chỉ số cũ:</strong>{' '}
              {`${record.start_meter_reading_manual_reason} - Đã đi đọc lúc ${moment(
                record.start_meter_reading_manual_read_at
              )
                .utc(7)
                .format('DD/MM/YYYY HH:mm')}`}{' '}
              - Cập nhật lên hệ thống bởi {record.start_meter_reading_manual_by} lúc{' '}
              {moment(record.start_meter_reading_manual_at).format('DD/MM/YYYY HH:mm')}
            </div>
          )}

          {!isNullOrEmpty(record?.end_meter_reading_manual_reason) && (
            <div style={{ marginTop: '4px' }}>
              <strong>Lý do đc chỉ số mới:</strong>{' '}
              {`${record.end_meter_reading_manual_reason} - Đã đi đọc lúc ${moment(
                record.end_meter_reading_manual_read_at
              )
                .utc(7)
                .format('DD/MM/YYYY HH:mm')}`}{' '}
              - Cập nhật lên hệ thống bởi {record.end_meter_reading_manual_by} lúc{' '}
              {moment(record.end_meter_reading_manual_at).format('DD/MM/YYYY HH:mm')}
            </div>
          )}
        </div>
      ),
      width: 300
    }
  ];

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleCustIdChange = (e) => {
    setCustId(e.target.value);
  };

  const [loading, setLoading] = useState(false);
  const handleExportExcelButtonClick = async () => {
    try {
      let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
      if (!isEmpty(user)) {
        user = JSON.parse(user);
      }
      setLoading(true);
      const fromDate = moment(selectedMonth + '-01');
      const response = await axios.get(`${URL_API}/api/statistics-month/export`, {
        params: {
          keyWord: search ?? undefined,
          community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
          period: fromDate.format('YYYY-MM-DD'),
          dataStatus: dataStatus,
          listCust: selectedFavoriteFilter
            ? favoriteFilters.find((f) => f.value === selectedFavoriteFilter)?.item_ids?.join(',')
            : undefined,
          ...dataFilterAdvance
        },
        headers: {
          Authorization: `Bearer ${user?.accessToken}`
        },
        responseType: 'blob'
      });
      const type = response.headers['content-type'];
      const blob = new Blob([response.data], { type: type });
      const link1 = document.createElement('a');
      link1.href = window.URL.createObjectURL(blob);
      link1.setAttribute('download', `Thong_ke_tieu_thu_thang_${selectedMonth}.xlsx`);
      document.body.appendChild(link1);
      link1.click();
    } catch (error) {
      console.log(error);
      showError(
        'Kỳ tính cước chưa được gán cấu hình ghi số' || 'Vui lòng liên hệ admin để được hỗ trợ'
      );
    } finally {
      setLoading(false);
    }
  };
  const [loadingSync, setLoadingSync] = useState(false);
  const handleCalculateButtonClick = async () => {
    try {
      setLoadingSync(true);
      const fromDate = moment(selectedMonth + '-01');
      const res = await apiCalculateStatisticsMonth({
        keyWord: search ?? undefined,
        community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
        period: fromDate.format('YYYY-MM-DD'),
        ...dataFilterAdvance
      });
      message.success('Tính toán lại thành công !');
      fetchData();
    } catch (e) {
      console.log(e);
      message.error('Có lỗi xảy ra !');
    } finally {
      setLoadingSync(false);
    }
  };
  const [loadingFetchChart, setLoadingFetchChart] = useState(false);
  const [dataStatisticsDetail, setDataStatisticsDetail] = useState(null);
  const fetchDataChart = async (customerId) => {
    try {
      const fromDate = moment(selectedMonth + '-01');
      setLoadingFetchChart(true);
      const res = await apiGetStatisticsDataByMonthByCustomerV2({
        customer_id: customerId,
        period: fromDate.format('YYYY-MM-DD') // convertLocaltimeToUTC(fromDate, '00:00:00.000'),
      });
      if (!res?.data?.data?.length) {
        showError('Khách hàng bạn chọn không có dữ liệu tiêu thụ theo ngày');
        setSelectedRowKey(null);
        return;
      }
      setDataStatisticsDetail(res?.data?.data);
      const convertData = [
        {
          name: 'Tiêu thụ ngày',
          data: res?.data?.data?.map((item) =>
            isNumber(item?.water_consumption_of_the_day) ? item?.water_consumption_of_the_day : 0
          ),
          type: 'bar'
        }
      ];
      setDataCharts(convertData);
      console.log(convertData);

      const convertLabel = res?.data?.data?.map(
        (item) => item?.denseData_startCollectionTime ?? 'chưa có dữ liệu'
      );
      setLabelCharts(convertLabel);
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingFetchChart(false);
    }
  };

  const handleRowClick = async (row) => {
    setSelectedRowKey(row?.stt);
    setSelectedRow(row);
    fetchDataChart(row?.customer_id);
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };

  const clearFilter = () => {
    setSearch('');
    setCurrentPage(1);
    setSelectedMonth(previousMonthDate.format('YYYY-MM'));
    setDataFilterAdvance({});
    setFlagSearch(!flagSearch);
  };

  return (
    <div>
      <ModalAdjustConsumption
        open={isOpenModalAdjust}
        onClose={() => setIsOpenModalAdjust(false)}
        record={adjustRow}
        fetchData={fetchData}
      />
      <ModalUpdateStartMeterReading
        open={isOpenModalStartMeter}
        onClose={() => setIsOpenModalStartMeter(false)}
        record={startMeterRow}
        fetchData={fetchData}
      />
      <ModalUpdateEndMeterReading
        open={isOpenModalEndMeter}
        onClose={() => setIsOpenModalEndMeter(false)}
        record={endMeterRow}
        fetchData={fetchData}
      />
      <Modal
        title="Danh sách yêu cầu tính toán"
        open={isOpenModalProcess}
        onCancel={() => setIsOpenModalProcess(false)}
        footer={null}
        width={1200}
        destroyOnClose={true}>
        <ProcessManagementList />
      </Modal>
      <ModalImportManualReadings
        visible={isOpenModalImport}
        onCancel={() => {
          setIsOpenModalImport(false);
          fetchData();
        }}
        selectedMonth={selectedMonth ? moment(selectedMonth + '-01').format('YYYY-MM-DD') : null}
      />
      <Row justify="space-between" align="middle">
        <Col>
          <Typography.Title level={4} style={{ color: '#0051A9' }}>
            Thống kê tiêu thụ theo tháng cước
          </Typography.Title>
        </Col>
        <Col>
          {consumption.export && (
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExportExcelButtonClick}
              loading={loading}
              style={{
                backgroundColor: '#EAF5EF',
                borderColor: '#EAF5EF',
                color: '#0051A9',
                height: '36px',
                fontWeight: '500'
              }}>
              Xuất báo cáo
            </Button>
          )}
          {consumption.calculate && (
            <Popconfirm
              title="Xác nhận"
              description="Bạn có chắc chắn muốn thực hiện tính toán lại không?"
              onConfirm={handleCalculateButtonClick}
              // onCancel={cancel}
              okText="Xác nhận"
              cancelText="Huỷ">
              <Button
                icon={<SyncOutlined />}
                // onClick={handleCalculateButtonClick}
                loading={loadingSync}
                style={{
                  backgroundColor: '#EAF5EF',
                  borderColor: '#EAF5EF',
                  color: '#0051A9',
                  height: '36px',
                  fontWeight: '500',
                  marginLeft: '8px'
                }}>
                Tính toán lại
              </Button>
            </Popconfirm>
          )}
          {consumption.calculate && (
            <Button
              onClick={() => setIsOpenModalProcess(true)}
              style={{
                backgroundColor: '#EAF5EF',
                borderColor: '#EAF5EF',
                color: '#0051A9',
                height: '36px',
                fontWeight: '500',
                marginLeft: '8px'
              }}>
              Xem các yêu cầu tính
            </Button>
          )}
          {consumption.manualImport && (
            <Button
              icon={<UploadOutlined />}
              onClick={() => setIsOpenModalImport(true)}
              style={{
                backgroundColor: '#EAF5EF',
                borderColor: '#EAF5EF',
                color: '#0051A9',
                height: '36px',
                fontWeight: '500',
                marginLeft: '8px'
              }}>
              Import chỉ số thủ công
            </Button>
          )}
        </Col>
      </Row>
      <Card
        bodyStyle={{
          padding: '8px'
        }}>
        <Row gutter={[8, 8]} style={{ marginBottom: '16px' }}>
          <Col md={1} xs={1}>
            <Button
              icon={<FilterOutlined />}
              onClick={openDrawer}
              style={{
                backgroundColor: '#F4F5F7',
                color: '#626D7C',
                border: 'none',
                width: '100%'
              }}
            />
          </Col>
          <Col md={3} xs={6}>
            <Select
              style={{ width: '100%', height: '36px' }}
              placeholder="Chọn năm"
              value={selectedYear}
              onChange={handleYearChange}>
              {generateYearOptions().map((year) => (
                <Option key={year.value} value={year.value}>
                  {year.label}
                </Option>
              ))}
            </Select>
          </Col>
          <Col md={5} xs={8}>
            <Select
              style={{ width: '100%', height: '36px' }}
              placeholder="Chọn tháng cước"
              value={selectedMonth}
              onChange={handleMonthChange}>
              {generateMonthOptions().map((month) => (
                <Option key={month.value} value={month.value}>
                  {month.label}
                </Option>
              ))}
            </Select>
          </Col>
          <Col md={5} xs={8}>
            <Select
              placeholder="Chọn Bộ lọc theo dõi..."
              value={selectedFavoriteFilter}
              onChange={(value) => {
                setSelectedFavoriteFilter(value);
                setCurrentPage(1);
              }}
              loading={loadingFavoriteFilters}
              allowClear
              options={favoriteFilters}
              style={{ width: '100%', height: '36px' }}
            />
          </Col>
          <Col md={5} xs={6}>
            <Input
              style={{ height: '36px', width: '100%' }}
              size="small"
              placeholder="Tìm kiếm theo mã KH, imei..."
              value={search}
              onChange={handleSearchChange}
              onPressEnter={() => {
                setCurrentPage(1);
                setFlagSearch(!flagSearch);
              }}
            />
          </Col>

          {/* <Col md={5} xs={6}>
            <SelectCommunity value={selectedCommunity} onChange={setSelectedCommunity} />
          </Col> */}

          <Col md={5} sm={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Space>
              <Button
                style={{
                  border: 'none',
                  backgroundColor: '#F4F5F7',
                  width: '100%',
                  height: '36px'
                }}
                icon={<ClearOutlined />}
                onClick={clearFilter}>
                Xoá bộ lọc
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => {
                  setCurrentPage(1);
                  setFlagSearch(!flagSearch);
                }}
                style={{
                  height: '36px',
                  backgroundColor: '#0051A9',
                  borderColor: '#0051A9'
                  // fontSize: '18px'
                }}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
        <ConsumptionCard
          selectedMonth={selectedMonth}
          dataFilterAdvance={dataFilterAdvance}
          flagSearch={flagSearch}
          keyWord={search}
          setDataStatus={setDataStatus}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selectedFavoriteFilter={selectedFavoriteFilter}
          favoriteFilters={favoriteFilters}
        />
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          style={{ marginTop: '16px' }}
          items={[
            {
              key: 'all',
              label: 'Tất cả'
            },
            {
              key: 'with_data',
              label: 'Đủ dữ liệu'
            },
            {
              key: 'without_data',
              label: 'Chưa đủ dữ liệu'
            },
            {
              key: 'manual_reading',
              label: 'Vào chỉ số thủ công'
            },
            {
              key: 'not_yet_reading_date',
              label: 'Chưa đến ngày chốt số'
            }
          ]}
        />
      </Card>

      <Table
        bordered
        // size="middle"
        loading={loadingFetch}
        dataSource={data || []}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalItems,
          showSizeChanger: true,
          onChange: handleChangePage,
          onShowSizeChange: handleChangePageSize,
          showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`
        }}
        onRow={(record) => ({
          onClick: () => handleRowClick(record), // Click handler for rows
          style: {
            cursor: 'pointer',
            backgroundColor: selectedRowKey === record.stt ? '#e6f7ff' : undefined
          }
        })}
        style={{
          borderRadius: 0,
          thead: { backgroundColor: '#DBDFE5', color: '#626D7C' },
          fontSize: '30px'
        }}
        scroll={{ x: 'max-content', y: 400 }}
      />

      {selectedRowKey && (
        <>
          <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
            <Col md={10} xs={12}>
              <Card
                title={'Chi tiết sử dụng'}
                loading={loadingFetch}
                headStyle={{ backgroundColor: '#0051A9', color: '#FFF', fontSize: '15px' }}
                bodyStyle={{ padding: '16px' }}>
                <Typography style={{ fontSize: '15px', fontWeight: '400', color: '#1667a0' }}>
                  Mã khách hàng: <strong>{selectedRow?.customer_id}</strong>
                </Typography>
                <Typography style={{ fontSize: '15px', fontWeight: '400', color: '#1667a0' }}>
                  Tên khách hàng: <strong>{selectedRow?.customer_name}</strong>
                </Typography>
                <table
                  className="table col-12"
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginBottom: '16px',
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#1667a0',
                    marginTop: '16px'
                  }}>
                  <tbody>
                    <tr>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Kỳ hóa đơn: <strong>{moment(selectedRow?.period).format('MM/YYYY')}</strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Từ ngày: <strong>{selectedRow?.first_day ?? '-'}</strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Chỉ số cũ:{' '}
                        <strong>
                          {' '}
                          {!isNullOrEmpty(selectedRow?.start_reading)
                            ? formatCurrency(selectedRow?.start_reading, 3)
                            : '-'}
                        </strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Mạng lưới: <strong>{selectedRow?.route ?? '-'}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="cn_color"
                        style={{ border: '1px solid #ddd', padding: '8px' }}></td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Đến ngày: <strong>{selectedRow?.last_day ?? '-'}</strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Chỉ số mới:{' '}
                        <strong>
                          {!isNullOrEmpty(selectedRow?.end_reading)
                            ? formatCurrency(selectedRow?.end_reading, 3)
                            : '-'}
                        </strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Số m³ tiêu thụ:{' '}
                        <strong>
                          {' '}
                          {!isNullOrEmpty(selectedRow?.final_consumption)
                            ? formatCurrency(selectedRow?.final_consumption, 3)
                            : '-'}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Card>
            </Col>
            <Col md={14} xs={12}>
              <Card
                title={' Biểu đồ thống kê tiêu thụ theo ngày'}
                loading={loadingFetch}
                headStyle={{ backgroundColor: '#0051A9', color: '#FFF', fontSize: '15px' }}
                bodyStyle={{ padding: '16px' }}>
                {' '}
                {loadingFetchChart ? (
                  <Loading />
                ) : (
                  <>
                    {/* <Typography.Title style={{ fontSize: '16px', marginTop: '0px' }}>
                      {`${dataStatisticsDetail?.[0]?.customer_id} - ${dataStatisticsDetail?.[0]?.customer_name}`}{' '}
                      ({selectedMonth})
                    </Typography.Title> */}
                    <Chart
                      options={{
                        colors: COLORS,
                        chart: {
                          zoom: {
                            enabled: false
                          },
                          toolbar: {
                            show: true
                          }
                        },
                        plotOptions: {
                          bar: {
                            horizontal: false,
                            columnWidth: '18px',
                            borderRadius: 0
                          }
                        },
                        fill: {
                          opacity: 1
                        },
                        dataLabels: {
                          enabled: false
                        },
                        stroke: {
                          show: true,
                          width: 2,
                          colors: ['transparent']
                        },
                        labels: labelCharts,
                        yaxis: {
                          show: true
                        },
                        grid: {
                          show: true
                        },
                        tooltip: {
                          y: {
                            formatter: (val) => `${formatCurrency(val)} lít`
                          }
                        },
                        legend: {
                          horizontalAlign: 'left'
                        }
                      }}
                      type="bar"
                      series={dataCharts}
                      height={400}
                    />
                  </>
                )}
              </Card>
            </Col>
          </Row>
        </>
      )}
      <FilterAdvanceDrawer
        isOpen={isOpen}
        onDrawerClose={onDrawerClose}
        dataFilterAdvance={dataFilterAdvance}
        setDataFilterAdvance={setDataFilterAdvance}
        flagSearch={flagSearch}
        setFlagSearch={setFlagSearch}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}
